import ReloadButton from 'CMFW/button/ReloadButton';
import SaveButton from 'CMFW/button/SaveButton';
import NewButton from 'CMFW/button/NewButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import Checkbox from 'CMFW/input/Checkbox';
import TextInput from 'CMFW/input/TextInput';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { LoadingItem } from 'CMFW/layout/Loading';
import {
  ContainerLeft,
  ContainerLeftFooter,
  ContainerRight,
  EditorGapGreedy,
  EditorRow,
  ModuleContainer,
} from 'components/common/styles';
import LanguageSelect from 'components/selects/LanguageSelect';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import DialectsManageModel from '../../models/DialectsManageModel';

const DialectsTab: React.FC = () => {
  const forceRender = useForceRender();
  const moduleModel = useMemo(() => new DialectsManageModel({ render: forceRender }), [forceRender]);
  const isNew = moduleModel.itemUpdated?.id === moduleModel.NEW_CREATE_ID;

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={moduleModel}>
        <Split widthLeft={420}>
          <ContainerLeft>
            <Grid />
            <ContainerLeftFooter>
              <ReloadButton />
              <NewButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            <ItemLayout>
              <EditorRow>
                <LanguageWrapper>
                  <LanguageSelect keyName={'languageId'} disabled={!isNew} />
                </LanguageWrapper>
                <CodeWrapper>
                  <TextInput keyName={'code'} label={'Code'} disabled={!isNew} />
                </CodeWrapper>
                <NameWrapper>
                  <TextInput keyName={'name'} label={'Name'} />
                </NameWrapper>
                <SaveButton />
              </EditorRow>
              <EditorRow>
                <SsmlCodeWrapper>
                  <TextInput keyName={'ssmlCode'} label={'SSML Code'} />
                </SsmlCodeWrapper>
              </EditorRow>
              <EditorRow>
                <Checkbox keyName={'onlyTarget'} label={'Only Target'} />
              </EditorRow>
              <EditorGapGreedy />
            </ItemLayout>
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default DialectsTab;

const LanguageWrapper = styled.div`
  flex: 3;
`;

const CodeWrapper = styled.div`
  flex: 1;
`;

const NameWrapper = styled.div`
  flex: 2;
`;

const SsmlCodeWrapper = styled.div`
  width: 120px;
`;
